import type { StorageConditionMeta, StorageConditionPatch, TemperatureFamily } from '@/types/storage'

/**
 * Draft-state helpers for the Storage Conditions dialog. Pure so they are
 * covered: this repo's vitest only collects `src/**\/*.test.ts`.
 */

/** One condition as edited in the dialog. */
export type ConditionDraft = {
  label: string
  temperature: string
  family: TemperatureFamily
  persistent: boolean
  active: boolean
}

/**
 * Only the fields the draft changed, or null when it changed nothing — so
 * editing a row and setting it back leaves nothing to save. Text is compared
 * trimmed, the way the server stores it.
 */
export function conditionPatch(saved: StorageConditionMeta, draft: ConditionDraft): StorageConditionPatch | null {
  const patch: StorageConditionPatch = {}
  if (draft.label.trim() !== saved.label) patch.label = draft.label.trim()
  if (draft.temperature.trim() !== saved.temperature) patch.temperature = draft.temperature.trim()
  if (draft.family !== (saved.family ?? 'AMBIENT_CRT')) patch.family = draft.family
  if (draft.persistent !== saved.persistent) patch.persistent = draft.persistent
  if (draft.active !== saved.active) patch.active = draft.active
  return Object.keys(patch).length > 0 ? patch : null
}
